export default "__VITE_ASSET__f1ce2b02__"